/* eslint-disable react/prop-types */
/** @jsx createElement */
// noinspection ES6UnusedImports
import createElement from '../jsx/createElement';

const ButtonsContainer = function ({ children }) {
  return (
    <div className="wrapper chatMessage agent embeddedServiceLiveAgentStateChatButtonMessage sfChatAskRate">
      <div className="chatContent">
        {children}
      </div>
    </div>
  );
};

const Button = function ({ text, description, value }) {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a
      href="#"
      className="rich-button-item uiButton--default uiButton embeddedServiceLiveAgentStateChatButtonItem sfMenuButton"
      aria-live="off"
      aria-label={description}
      data-value={value}
      title={description}
      style={{ fontSize: '2em' }}
    >
      {text}
    </a>
  );
};

const AskRating = function ([...ratings]) {
  return (
    <ButtonsContainer>
      {
        ratings.map(({ emoji, text, key }) => (
          <Button text={emoji} description={text} value={key} />
        ))
      }
    </ButtonsContainer>
  );
};

export default AskRating;
